/**
 * Functions that return or update timekeeping model or app data only.
 */

import { getAPIData, apiRequest } from "./axios";
import { API_PATHS } from "../../config/apiConfig";

// Getters
export async function getUnsignedTimesheetsCount() {
  const url = API_PATHS.TIMEKEEPING.UNSIGNED_COUNT;
  return await getAPIData(url);
}

export async function getUnsignedTimesheets() {
  const url = `/timekeeping/getunsignedtimesheetsdetails`;
  return await getAPIData(url);
}

export async function getUserSchedule(userId, date) {
  const url = `/timekeeping/getuserschedule/${userId}/${date}`;
  return await getAPIData(url);
}

export async function getUserOnShift(date) {
  const url = `/timekeeping/getuseronshift/${date}`;
  return await getAPIData(url);
}

export async function getDailyTimesheet(date) {
  const url = `/timekeeping/getdailytimesheet/${date}`;
  return await getAPIData(url);
}

export async function getWeekOfShifts(date, userId = null) {
  let url = `/timekeeping/getweekofshifts/${date}`;
  if (userId) {
    url += `?user_id=${userId}`;
  }
  return await getAPIData(url);
}

export async function getWeekOfHoursLogs(userID, weekEnding) {
  const url = `/timekeeping/getweekofhourslogs/${userID}/${weekEnding}`;
  return await getAPIData(url);
}

export async function getcombinedWeeklyHours(userID, weekEnding) {
  const url = `/timekeeping/getcombinedweeklyhours/${userID}/${weekEnding}`;
  return await getAPIData(url);
}

export async function getShowTimesheetSigningPrompt() {
  const url = `/timekeeping/getshowtimesheetsigningprompt/`;
  return await getAPIData(url);
}

export async function getWorkerTimesheetWeekEnding() {
  const url = `/timekeeping/getworkertimesheetweekending/`;
  return await getAPIData(url);
}

export async function getWorkerTimesheetSignature(userID, weekEnding) {
  const url = `/timekeeping/getworkertimesheetsignature/${userID}/${weekEnding}`;
  return await getAPIData(url);
}

export async function checkTimesheetExists(weekEnding) {
  const url = `/timekeeping/checktimesheetexists/${weekEnding}`;
  return await getAPIData(url);
}

// Setters
export async function clockInUser(payload) {
  const url = "/timekeeping/clockinuser";
  return await apiRequest(url, payload, { method: "POST" });
}

export async function cancelClockIn(payload) {
  const url = "/timekeeping/cancelclockin";
  return await apiRequest(url, payload, { method: "POST" });
}

export async function clockOutUser(payload) {
  const url = "/timekeeping/clockoutuser";
  return await apiRequest(url, payload, { method: "POST" });
}

export async function editShiftData(payload) {
  const url = "/timekeeping/updateday";
  return await apiRequest(url, payload, { method: "POST" });
}

export async function saveShiftData(payload) {
  const url = "/timekeeping/saveshift";
  return await apiRequest(url, payload, { method: "POST" });
}

export async function saveWorkerTimesheet(payload) {
  const url = "/timekeeping/saveworkertimesheet";
  return await apiRequest(url, payload, { method: "POST" });
}

export async function saveManagerTimesheet(payload) {
  const url = "/timekeeping/savemanagertimesheet";
  return await apiRequest(url, payload, { method: "POST" });
}
